import React from 'react';
import type {SystemStyleObject} from '@tempo/core';
import {
	Popover as TempoPopover,
	PopoverTrigger as TempoPopoverTrigger,
	PopoverContent as TempoPopoverContent,
	PopoverBody as TempoPopoverBody,
	PopoverHeader as TempoPopoverHeader,
	PopoverFooter as TempoPopoverFooter,
	PopoverArrow as TempoPopoverArrow,
	PopoverCloseButton as TempoPopoverCloseButton,
} from '@tempo/core';

type TempoPopoverProps = React.ComponentProps<typeof TempoPopover>;
type TempoPopoverContentProps = React.ComponentProps<
	typeof TempoPopoverContent
>;

const POPOVER_CONTENT_STYLES: SystemStyleObject = {
	zIndex: 'popover',
};

export function Popover(props: TempoPopoverProps) {
	return <TempoPopover {...props} />;
}

export const PopoverTrigger = TempoPopoverTrigger;
export const PopoverBody = TempoPopoverBody;
export const PopoverHeader = TempoPopoverHeader;
export const PopoverFooter = TempoPopoverFooter;
export const PopoverArrow = TempoPopoverArrow;
export const PopoverCloseButton = TempoPopoverCloseButton;

export type PopoverContentProps = TempoPopoverContentProps & {
	sx?: SystemStyleObject;
};

export function PopoverContent({sx, ...rest}: PopoverContentProps) {
	return (
		<TempoPopoverContent
			{...rest}
			sx={{
				...POPOVER_CONTENT_STYLES,
				...sx,
			}}
		/>
	);
}

export default Popover;
